/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ src: NonNullable<unknown> }} Jobs_Title_PreviewInputs */

const cs_jobs_title_preview = /** @type {(inputs: Jobs_Title_PreviewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.src} · náhled změn`)
};

const en_jobs_title_preview = /** @type {(inputs: Jobs_Title_PreviewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.src} · change preview`)
};

/**
* | output |
* | --- |
* | "{src} · change preview" |
*
* @param {Jobs_Title_PreviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_title_preview = /** @type {((inputs: Jobs_Title_PreviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Title_PreviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_title_preview(inputs)
	return cs_jobs_title_preview(inputs)
});